import styled from 'styled-components';

export const PaymentSection = styled.section`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-large);
`;

export const SectionHeader = styled.header`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-xsmall);
`;

export const Text = styled.p`
  font-size: var(--font-size-text-md);
  font-weight: var(--font-weight-regular);
  line-height: 24px;
  color: var(--grey-500);
`;
